import React from 'react';
import styled from "styled-components";
import twitter from "../assets/twitter.png"
import telegram from "../assets/telegram.png"


const StyledFooter = styled.div`
background: transparent;
width:100%;
color:#fff;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
background:#964B9D;
`
const SocialWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin:1rem 0;
    img {
    width: 50px;
    height: 50px;
    margin:0 1rem;
    }
`
const Footer = () => {
    return (
        <StyledFooter>
            <SocialWrapper>
                <a href="#" target="_blank" rel="noreferrer nopenner"><img src={twitter} alt="twitter"/></a>
                <a href="#" target="_blank" rel="noreferrer nopenner"><img src={telegram} alt="telegram"/></a>
            </SocialWrapper>
           All Rights Reserved &copy; Ambient Finance  2020
        </StyledFooter>

    );
};

export default Footer;